<template>
  <div class="history-page">
    <section class="history-hero user-page-banner">
      <div class="history-icon"><CIcon name="cil-history" size="xl" /></div>
      <div>
        <h2>{{ $t('mainuser.tabHistory') }}</h2>
      </div>
    </section>
    <CCard class="history-card">
      <CCardHeader class="history-card-header"><h4>{{ $t('userHistory.allTransactions') }}</h4></CCardHeader>
      <UHistoryTable ref="historyTable" @show-detail="showDetail" />
    </CCard>
    <TicketDetailModal v-if="selectedReport" @close="selectedReport = null">
      <UReportDetail :report="selectedReport" @close="selectedReport = null" @refresh="refreshHistory" />
    </TicketDetailModal>
  </div>
</template>

<script>
import UHistoryTable from '@/components/user/Uhistorytable.vue';
import UReportDetail from './UReportDetail.vue';
import TicketDetailModal from '@/components/common/TicketDetailModal.vue';

export default {
  name: 'UserHistory',
  components: { UHistoryTable, UReportDetail, TicketDetailModal },
  data: () => ({ selectedReport: null }),
  methods: {
    showDetail(item) {
      this.selectedReport = { ...item };
      this.$nextTick(() => {
        const detail = document.querySelector('.detail-card');
        if (detail) detail.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    },
    refreshHistory() {
      this.selectedReport = null;
      if (this.$refs.historyTable) this.$refs.historyTable.loadHistory();
    }
  }
};
</script>

<style scoped>
.history-page {
  width: 100%;
  max-width: none;
  margin: 0;
  padding: 0 0 30px;
}
.history-hero {
  display: flex;
  align-items: center;
  gap: 18px;
  margin-bottom: 22px;
  padding: 24px;
  border-radius: 12px !important;
  color: #fff;
  background: #1e40af;
  box-shadow: none;
}
.history-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 54px;
  height: 54px;
  flex: 0 0 54px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.14);
}
.history-hero h2,
.history-card-header h4 {
  margin: 0;
  font-weight: 800;
}
.history-hero h2 {
  font-size: 1.6rem;
}
.history-hero p {
  margin: 5px 0 0;
  color: rgba(255, 255, 255, 0.8);
}
.history-card {
  background: #ffffff !important;
  border: 1px solid rgba(37, 99, 235, 0.10) !important;
  border-radius: 12px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.04) !important;
}
.history-card-header {
  padding: 18px 22px;
  color: #1e40af !important;
  background: #f8fafc !important;
  border-bottom: 1px solid rgba(37, 99, 235, 0.10) !important;
}
@media (max-width: 991.98px) {
  .history-page {
    padding: 0 0 24px;
  }
  .history-hero {
    padding: 18px;
    border-radius: 12px !important;
  }
  .history-icon {
    width: 46px;
    height: 46px;
    flex-basis: 46px;
    border-radius: 13px;
  }
  .history-hero h2 {
    font-size: 1.3rem;
  }
  .history-hero p {
    font-size: 0.82rem;
  }
  .history-card {
    border-radius: 12px !important;
  }
  .history-card-header {
    padding: 15px 16px;
  }
  .history-card-header h4 {
    font-size: 1.05rem;
  }
}
</style>
